import React from 'react'
import { UserMenuContextProvider } from './UserMenuContext'
import LoggedUserHeader from './LoggedUserHeader'

export default () => (
    <UserMenuContextProvider>
        <LoggedUserHeader />
    </UserMenuContextProvider>
)
